import React, {useState} from 'react'
import {Button, Divider, message} from 'antd'
import {GoogleCircleFilled} from '@ant-design/icons'
import {Link, redirect, useNavigate} from 'react-router-dom'
import {instance as userService} from '../../services/UserService'
import {useIntl} from 'react-intl'
import {SignUpForm} from './SignUpForm'
import './loginPage.less'
import {ChangePasswordForm} from './ChangePasswordForm'

export function ChangePasswordPage() {
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const [isEmailSent, setEmailSent] = useState(false)
  const intl = useIntl()
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="container">
        <Link className="logo" to="/">
          <h1>TerraSketch</h1>
        </Link>
        <h2>{intl.formatMessage({id: 'changePassword'})}</h2>
        {isEmailSent ? (
          <div className="email-check">
            <div>{intl.formatMessage({id: 'checkYourEmail'})}</div>
            <Button
              size="large"
              type="primary"
              onClick={async () => {
                navigate('/login')
              }}
            >
              {intl.formatMessage({id: 'ok'})}
            </Button>
          </div>
        ) : (
          <>
            <ChangePasswordForm setEmailSent={setEmailSent}></ChangePasswordForm>
          </>
        )}
      </div>
    </div>
  )
}
